module.exports = __webpack_public_path__ + "static/media/vencimientostickets-07-rojo.ab6bea1a.svg";